__webpack_public_path__ = window.location.pathname === '/' || process.env.NODE_ENV === 'development' 
    ? '/'
    : `/${window.location.pathname.split('/')[1]}/`;